// @flow

import React from 'react';
import { jobs as t } from 'helpers/translation';
import { optionsFromObject } from 'helpers/select.helper';
import Select from 'components/Select';

type Props = {
  totalRecords: number | string,
  handleChange: Function,
  searchParams: any
};

export default ({ totalRecords, handleChange, searchParams }: Props) => {
  const options = optionsFromObject(t.sort_by.items);

  return (
    <div className="jobs-status-bar">
      <div className="jobs-status-bar__total">
        <span className='d-none d-sm-inline'>{t.status_bar.total} </span>
        <strong>{totalRecords} </strong>
        {t.status_bar.jobs}
      </div>
      <div className="jobs-status-bar__sort">
        <span className='d-none d-sm-inline'>{t.sort_by.label}:</span>
        <Select
          isSearchable={false}
          placeholder={t.sort_by.items.default}
          value={options.find(s => s.value === searchParams.sort) || null}
          options={options}
          onChange={handleChange('sort')}
        />
      </div>
    </div>
  );
};
